module.exports = __webpack_public_path__ + "static/media/Udinese.bd402276.jpg";